document.addEventListener('DOMContentLoaded', ()=> {
    const purchasePoint = document.getElementById('purchase-point');
    const FORM_SESSION_KEY = "warrantyForm"
    const modalOpenTrigger = document.getElementById('pop-trigger');
    const modalCloseBtn = document.getElementById('modal_close')
    const modal = document.getElementById('find-order-id');
    const activateWarrantyForm = document.getElementById("activate-form");
    const selectGiftBtns = document.querySelectorAll('.btn-gift');
    const stars = document.querySelectorAll('.star');
    const ratingInput = document.querySelector('input[name="ratings"]')
    const copyToAmnzTextArea = document.getElementById('copy-to-amazon')
    const addressForm = document.getElementById('giftAddress');
    const otherPosForm = document.getElementById('other-pos-form')
    const dateInput = document.getElementsByName('date')[0]
    

    if (otherPosForm) {
        otherPosForm.addEventListener('submit', (e) => {
            e.preventDefault()
           
            window.location.href="customer-reviews"
        })
    }
    if (dateInput) {
        
        dateInput.addEventListener('click', () => dateInput.showPicker && dateInput.showPicker());
    }

    if (modalOpenTrigger){
        
        modalOpenTrigger.addEventListener('click', ()=>{
            modal.classList.remove('close-modal')
        })
    }
    if (modalCloseBtn){
        modalCloseBtn.addEventListener('click', ()=> {
            modal.classList.add('close-modal')
        })
    }

    
    if (copyToAmnzTextArea){
        const comment = getFormData()['comment']
        copyToAmnzTextArea.value = comment
    }

    async function validateOrderId(orderId){
       
        try {
           
            const response = await fetch(`https://eara-data-aggregation-api.onrender.com/api/v1/verify_order/${orderId}`, {
            method: "GET",
            });
            
            if (response.status === 200) {
                const data = await response.json();
                
                return data["exists"]; 
            } else if (response.status === 500) {
     
                const errorData = await response.json();
                return { error: errorData.error || "Server error" };
            } else {
      
                return false;
            }
        } catch (error) {
            return { error: error.message || "Network error" };
        }
    }

    async function updateShopifyData(data){
        return true
    }

    function showError(elementId){
        const element = document.getElementById(elementId)
        const errorContainer = element.querySelector('.err-container');
        if (element && errorContainer.classList.contains("hidden")){
            errorContainer.classList.remove("hidden")
        }
    }

    function clearError(elementId){
        const element = document.getElementById(elementId)
        const errorContainer = element.querySelector('.err-container');
        if (element && !errorContainer.classList.contains("hidden")){
            errorContainer.classList.add("hidden")
        }
    }

    function getFormData(){
        const data = sessionStorage.getItem(FORM_SESSION_KEY);
        return data ? JSON.parse(data): {}
    }

    function saveFormData(data){
        const currentData = getFormData();
        const updatedData = {...currentData, ...data}
        sessionStorage.setItem(FORM_SESSION_KEY, JSON.stringify(updatedData))
    }
    function clearData(){
        sessionStorage.removeItem(FORM_SESSION_KEY)
    }

    function setUpButtonHandler(btnId, handlerFn){
        const btn = document.getElementById(btnId);
         if (!btn) return

         btn.addEventListener('click', (e) => {
            e.preventDefault()
            handlerFn(e);
         })
    }

    
    setUpButtonHandler('btn-pos', ()=> {
        const selectedPoint = document.querySelector('input[name="pos"]:checked')
        if (selectedPoint){
            const value = selectedPoint.value
            saveFormData({"pointOfPurchase": value});
            clearError("purchase-point");
            if (value.trim().toLowerCase() === "amazon"){
                
                window.location.href = "activate-warranty"
            }else {
                window.location.href = "complete-warranty"
            }
        } else {
            showError("purchase-point");
        }
    })

    if (activateWarrantyForm){

        activateWarrantyForm.addEventListener('submit', async (e)=> {
            
            e.preventDefault();
            const inputs = activateWarrantyForm.querySelectorAll("input");
            const orderIdInput = activateWarrantyForm.querySelector('input[name="order_id"]')
            const invalidOrderElement = activateWarrantyForm.querySelector(".order-id-err");
            let isValidForm = true;
            let isValidOrderId;
    
            inputs.forEach(input => {
                if(!input.checkValidity()){
                    input.classList.add("err-outline")
                    isValidForm = false
                }
            });
    
            inputs.forEach(input => {
                input.addEventListener("input", ()=>{
                    if (input.checkValidity()){
                        input.classList.remove("err-outline");
                    }
                    if (input.name === "order_id" && !invalidOrderElement.classList.contains("hidden")){
                        invalidOrderElement.classList.add("hidden")
                    }
                })
            })
            
    
            if (!isValidForm) return
    
            const orderId = orderIdInput.value
            isValidOrderId = await validateOrderId(orderId);
            
            let serverError = null
            serverError = isValidOrderId["error"]

            if (serverError) {
                const serverError = activateWarrantyForm.querySelector(".server-err")
                serverError.classList.remove(".server-err")
                return
            }
            
            if (!isValidOrderId){
                
                inputs.forEach(input => {
                    if (input.name === "order_id"){
                        input.classList.add("err-outline")
                        invalidOrderElement.classList.remove("hidden")
                    }
                })
                return
            }
            
            const data = {};
            inputs.forEach(input => {
               if (input.name === "first_name") {
                    data["first_name"] = input.value;
                }
               if (input.name === "last_name") {
                    data["last_name"] = input.value;
                }
    
                if (input.name === "email") {
                    data["email"] = input.value;
                }
    
                if (input.name === "date") {
                    data["purchased"] = input.value;
                }
    
                if (input.name === "order_id") {
                    data["orderId"] = input.value;
                }
    
                if (input.name === "consent") {
                    data["consent"] = input.value;
                }
                if (input.name === "telephone") {
                    data['phone'] = input.value
                }
    
            })
            saveFormData(data)
            window.location.href= "select-gift"
            
        })
    }

    if (selectGiftBtns){

        selectGiftBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                const parentNode = btn.closest('.gift_')
                const giftName = parentNode.querySelector('input').value;
                const giftUrl = parentNode.querySelector('img').src;
                if (giftName){
                    clearError("gift")
                    saveFormData({'gift': giftName, 'giftUrl': giftUrl});
                    window.location.href = "share-experience"

                } else {
                    showError("gift")
                }
            })
        })
    }

    let currentRating = 0

    function highlightStars(value) {
        
        stars.forEach(star => {
            const starValue = parseInt(star.dataset.index);
            star.classList.toggle('hovered', starValue <= value);
            star.classList.toggle('selected', starValue <= currentRating);
        });
    }

    stars.forEach(star => {
        star.addEventListener('mouseenter', ()=>{
            const value = parseInt(star.dataset.index);
            highlightStars(value);
        })

        star.addEventListener('mouseleave', () => {
            highlightStars(currentRating)
        })

        star.addEventListener("click", ()=> {
            currentRating = parseInt(star.dataset.index);
            ratingInput.value = currentRating
            highlightStars(currentRating)
        })
    });

    setUpButtonHandler('experience-btn', () => {
        const comment = document.getElementById('copy-comment');

        if (comment.value.trim().length >= 30 && ratingInput.value >= 1){
            saveFormData({
                "comment": comment.value.trim(),
                "rating": ratingInput.value
            })
            clearError('share-experience')
            window.location.href="share-experience-on-amazon"
        } else {
            showError('share-experience')
        }
    })

    setUpButtonHandler('cp-amzn', ()=> {
        const comment = getFormData()['comment']
        try {
            navigator.clipboard.writeText(comment);
            const cpAmzn = document.getElementById('cp-amzn');
            cpAmzn.textContent = "COPIED!"
            window.open('https://www.amazon.com/review/create-review/?ie=UTF8&channel=awUDPv3&asin=B0DLTGPZZZ', '_blank', 'noopener noreferrer')
            const cpComplete = document.getElementById('cp-complete');
            cpComplete.addEventListener('click', ()=>{
                
                window.location.href = "warranty-gift-address"
            })
            setTimeout(() => {
               cpComplete.disabled = false;
               cpComplete.style.backgroundColor = "#ffa73f" 
            }, 3000);
        } catch (error) {
            console.error('Failed')
        }
    })

    addressForm.addEventListener('submit', async (e) => {
        e.preventDefault()
        const inputs = addressForm.querySelectorAll("input");    
        let isValidForm = true;
            
    
        inputs.forEach(input => {
            if(!input.checkValidity()){
                input.classList.add("err-outline")
                isValidForm = false
            }
        });
    
        inputs.forEach(input => {
            input.addEventListener("input", ()=>{
                if (input.checkValidity()){
                    input.classList.remove("err-outline");
                }
        
            })
        })     
    
        if (!isValidForm) return
        
        let address;
        inputs.forEach(input => {
            if (input.name === 'address'){
                address = input.value
            }
        })
        if (!address) return

        const data = getFormData()
        const consent = data['consent'] === 'yes'? true : false;
        const payload = {
            'customer': {
                'first_name': data['name'],
                'last_name': '',
                'email': data['email'],
                "accepts_marketing": true,
                "marketing_opt_in_level": "single_opt_in"
            },
            'warranty': {
                'order_id': data['order_id'],
                'purchase_point': data['pointOfPurchase'],
                'purchase_date': data['purchased'],
                'consent': consent,
                'rating': data['rating'],
                'review': data['comment']
            },
            'address': {
                'address': '1234, Boulevard Lane',
                'phone': data['phone'],
                'zip': '90210',
                'country': 'USA',
                'city': 'Miami',
                'state': 'Florida'
            }
        }
        const resp = await updateShopifyData(payload);
        console.log(resp)

        if(submitted) {
            window.location.href = "warranty-confirmation"
            return
        }
        showError('gift-address'); 

    })


})